export var SYSTEM_PROBLEM_NOTIFICATION_KEY = 'system_problem_internet';
export var CHARS_LIMIT_NOTIFICATION_KEY = 'chars_limit';